import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
// import './WetrackedProcess.css';

interface StepProps {
  icon: string;
  label: string;
  active: boolean;
  completed: boolean;
}

const Step: React.FC<StepProps> = ({ icon, label, active, completed }) => {
  return (
    <div className="step-container">
      <motion.div
        className={`step-icon ${active ? 'active' : ''} ${completed ? 'completed' : ''}`}
        initial={{ scale: 1, opacity: 0.6 }}
        animate={{ scale: active ? 1.2 : 1, opacity: active ? 1 : 0.6 }}
        transition={{ duration: 0.5 }}
      >
        <div className="icon-circle">{icon}</div>
      </motion.div>
      <div className="checkmark">
        {completed && <div className="circle">✔️</div>}
      </div>
      <div className="label-text">{label}</div>
    </div>
  );
};

const steps = [
  { icon: '👤', label: 'Customer' },
  { icon: '📘', label: 'Facebook Ad' },
  { icon: '🛒', label: 'Shopify' },
  { icon: '📊', label: 'WeTracked' },
  { icon: '📣', label: 'Meta Ads Manager' },
];

const WetrackedProcess: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev < steps.length ? prev + 1 : 0));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="process-wrapper">
      <h4 className="subtitle">How are we doing it?</h4>
      <h2 className="title">Your customers purchased, wetracked.</h2>
      <div className="step-row">
        {steps.map((step, index) => (
          <div key={index} className="step-container">
            <motion.div
              className={`step-icon ${index === activeStep ? 'active' : ''} ${index < activeStep ? 'completed' : ''}`}
              initial={{ scale: 1, opacity: 0.6 }}
              animate={{ scale: index === activeStep ? 1.2 : 1, opacity: index === activeStep ? 1 : 0.6 }}
              transition={{ duration: 0.5 }}
            >
              <div className="icon-circle">{step.icon}</div>
            </motion.div>
            {index < activeStep && <div className="checkmark"><div className="circle">✔️</div></div>}
            <div className="label-text">{step.label}</div>

            {/* Connector line only if not the last step */}
            {index !== steps.length - 1 && <div className="connector-line" />}
          </div>
        ))}
      </div>

      <div className="step-description">
        {activeStep > 0 && activeStep <= steps.length && steps[activeStep - 1].label.toLowerCase()} detected
      </div>
    </div>
  );
};

export default WetrackedProcess;